import Emily from "../components/assets/Emily.png"
import Sophia from '../components/assets/Sophia.png'
import Alex from '../components/assets/view.jpg'

export const About=[
    
    {

        cmnt:"Electric scooter enthusiast on a mission to transform cities.",
        name: "Emily Greenfield",
        ocupation:"Founder and CEO",
        image:Emily

    },
    {
        cmnt:"The brains behind the innovative technology powering our scooters.",
        name: "Alex Martinez",
        ocupation:"Lead Engineer",
        image:Alex

    }
    ,{
        cmnt:" Your go-to person for all your scooter-related questions.",
        name: "Sophia Johnson:",
        ocupation:"Customer Experience Manager.",
        image:Sophia
    },]